import React from 'react';
import {faClipboardCheck} from '@fortawesome/free-solid-svg-icons/faClipboardCheck';

import Authenticated from 'Components/Layouts/Authenticated';
import StaffFormsChecklist from 'Components/HumanResources/StaffFormsChecklist';
import ViewCmsElementRecords from 'Components/Utilities/ViewCmsElementRecords';

import User from 'Services/User';

/**
 * A staff member's own staff forms: fill them in, and view or update what they have sent.
 * Everything filled in here is saved to their staff folder.
 */
export default class MyStaffForms extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return (
            <Authenticated title="My Forms" titleIcon={faClipboardCheck}>
                <div className="space-y-8">
                    <StaffFormsChecklist />

                    <section>
                        <h2 className="font-league-spartan font-bold text-2xl mb-1 mx-4">Everything I've filled in</h2>
                        <p className="text-gray-600 mb-4 mx-4">Pick a form to see each time you filled it in.</p>

                        <ViewCmsElementRecords
                            staff_form={true}
                            user_id={User.id}
                            push_to_history={false}
                        />
                    </section>
                </div>
            </Authenticated>
        );
    }
}
